import { Forms } from "../../interfaces/forms";

const priceForm: Forms = {
    formHeader: "מחיר",
    data: [
        {
            name: "price",
            label: "הקלד מחיר",
            fieldType: "text",
            placeholder: "הקלד מחיר"
        }
    ]
}
export default priceForm;
